@if (!loadingCapture) {
  <div class="capture-detail">
    <div class="capture-fixed mb-1"><app-capture-header [capture]="capture" /></div>
    @if (!loadingActivities) {
      <div class="capture-history">
        <table class="table table-striped mt-3">
          <tbody>
            @for (captureActivity of captureActivities; track captureActivity) {
              <tr>
                <td class="highlighted">
                  <div>{{ captureActivity.time | date: 'MM/dd/yyyy' }}</div>
                  <div>{{ captureActivity.time | date: 'hh:mm a' }}</div>
                </td>
                <td>
                  <strong>{{ captureActivity.title }}</strong>
                  <p>
                    @switch (captureActivity.action) {
                      @case (captureActivityActions.captureSnapshotCreated) {
                        <app-capture-snapshot-activity
                          [capture]="capture"
                          [captureSnapshot]="captureActivity.activity"
                          (snapshotActivityComplete)="onSnapshotActivityComplete($event)"
                          />
                      }
                      @default {
                        <span>{{ captureActivity.description }}</span>
                      }
                    }
                  </p>
                </td>
                <td class="highlighted">{{ getUserNameFromCaptureActivity(captureActivity) }}</td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    } @else {
      <mat-spinner />
    }
  </div>
} @else {
  <mat-spinner />
}
